export default {
  dueToday: {
    id: 'product_card_price_due_today',
    defaultMessage: 'due today',
  },
} as const
